import { lazy } from 'react';
import { useSelector } from 'react-redux';

// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import PrivateRoute from 'layout/PrivateLayout/index';

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard')));
const Help = Loadable(lazy(() => import('pages/help')));
const FAQ = Loadable(lazy(() => import('pages/help/FAQ')));
const ForecastPlots = Loadable(lazy(() => import('pages/help/ForecastPlots')));
const Payment = Loadable(lazy(() => import('pages/payment')));
const SubscriptionSuccess = Loadable(lazy(() => import('pages/payment/success')));
const PaymentHistory = Loadable(lazy(() => import('pages/payment/history')));
const ManageMyAssets = Loadable(lazy(() => import('pages/ManageMyAssets')));
const Settings = Loadable(lazy(() => import('pages/settings')));
const HistoricalEvent = Loadable(lazy(() => import('pages/HistoricalEvent')));

// ==============================|| MAIN ROUTING ||============================== //

const GenerateRoutes = (user) => {
    const baseRoutes = [
        {
            path: '/',
            element: (
                <PrivateRoute>
                    <DashboardDefault />
                </PrivateRoute>
            )
        },
        {
            path: '/help',
            element: (
                <PrivateRoute>
                    <Help />
                </PrivateRoute>
            )
        },
        {
            path: '/help/faq',
            element: (
                <PrivateRoute>
                    <FAQ />
                </PrivateRoute>
            )
        },
        {
            path: '/help/forecast-plots',
            element: (
                <PrivateRoute>
                    <ForecastPlots />
                </PrivateRoute>
            )
        },
        {
            path: '/payment',
            element: (
                <PrivateRoute>
                    <Payment />
                </PrivateRoute>
            )
        },
        {
            path: '/payment/history',
            element: (
                <PrivateRoute>
                    <PaymentHistory />
                </PrivateRoute>
            )
        },
        {
            path: '/payment/success',
            element: (
                <PrivateRoute>
                    <SubscriptionSuccess />
                </PrivateRoute>
            )
        },
        {
            path: '/settings',
            element: (
                <PrivateRoute>
                    <Settings />
                </PrivateRoute>
            )
        }
    ];
    if (user) {
        if (user.user_level >= user.user_levels.business || user.is_demo) {
            baseRoutes.push({
                path: '/historical-events',
                element: (
                    <PrivateRoute>
                        <HistoricalEvent />
                    </PrivateRoute>
                )
            });
        }
        if (user.user_level >= user.user_levels.business) {
            baseRoutes.push({
                path: '/manage-my-assets',
                element: (
                    <PrivateRoute>
                        <ManageMyAssets />
                    </PrivateRoute>
                )
            });
        }
    }
    return baseRoutes;
};

const HomeRoutes = () => {
    const { user } = useSelector((state) => state.account);
    return {
        path: '/',
        element: <MainLayout />,
        children: GenerateRoutes(user)
    };
};

export default HomeRoutes;
